<template>

    <div class="modal fade" id="searchProjectsModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="mdi mdi-close"></i></span></button>
                    <h4 class="modal-title" v-text="lang.get('projects.fg.header')"></h4>
                </div>
                <div class="modal-body no-padding">
                    <table class="table table-striped" v-if="getProjects.length > 0">
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th v-text="lang.get('global.name')"></th>
                                <th class="col-sm-2" v-text="lang.get('global.select')"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="project in getProjects">
                                <td>
                                    <label
                                        :for="'project-modal-' + project.uuid"
                                        style="white-space:nowrap;"
                                    >
                                        {{ project.project_name }}
                                    </label>
                                </td>
                                <td>
                                    <label
                                        :for="'project-modal-' + project.uuid"
                                    >
                                        {{project.number }} {{ project.name }}
                                    </label>
                                </td>
                                <td>
                                    <input type="checkbox" :id="'project-modal-' + project.uuid" v-model="selected" :value="project.uuid" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-body text-right">
                    <button class="btn btn-primary btn-sm" type="button" @click="close()">Geselecteerde ({{ selected.length }}) projecten gebruiken</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import Hub from '../../Hub';
import Lang from '../../Lang';
import axios from 'axios';

export default {

    computed:{
        ...mapGetters([
            "dataLoaded",
        ]),

        getProjects() {
            let projects = [];
            this.projects.forEach((project) => {
                if (this.excluded.indexOf(project.uuid) === -1) { projects.push(project); }
            });
            return projects;
        },

        getSelectedProjects() {
            let projects = [];
            this.projects.forEach((project) => {
                if (this.selected.indexOf(project.uuid) !== -1) {
                    projects.push({
                        name:project.name,
                        uuid:project.uuid,
                    });
                }
            });
            return projects;
        },
    },

    data() {
        return {
            lang:Lang,
            projects:[],
            selected:[],
        }
    },

    destroyed() {
        Hub.$off('open-project-selector', this.open);
    },

    methods: {

        check() {
            if (this.projects.length === 0) {
                this.fetch();
            }
        },

        close() {
            $('#searchProjectsModal').modal('hide');
            this.$emit("selected-projects", this.getSelectedProjects)
        },

        fetch() {
            axios.get(this.route('api.v1.projects.index', false))
                .then(response => this.projects = response.data.data);
        },

        open(){
            $('#searchProjectsModal').modal('show');
        },

    },

    mounted() {
        this.check();

        this.$nextTick(function () {
            Hub.$on('open-project-selector', this.open);
        }.bind(this));
    },

    name: "ProjectSelect",

    props: {
        excluded: {
            type:Array,
            default:function(){ return []; },
        },
    },

}


</script>
